import { SVGProps } from "react";

export function WarningIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 8V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />

      <circle cx="12" cy="20" r="1.25" fill="currentColor" />
    </svg>
  );
}
